import { UserRoleEnum } from 'core/enums';

export const SESSION_IDLE_MONITOR_ROLES: readonly UserRoleEnum[] = [
    UserRoleEnum.AdminSubRecipient,
    UserRoleEnum.AdminSubRecipientPlus,
];
